import { render } from "./DashboardVentaMes.vue?vue&type=template&id=551005e2&scoped=true"
import script from "./DashboardVentaMes.vue?vue&type=script&lang=js"
export * from "./DashboardVentaMes.vue?vue&type=script&lang=js"

import "./DashboardVentaMes.vue?vue&type=style&index=0&id=551005e2&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-551005e2"]])

export default __exports__